import { requestSaga } from 'common/utils/generators';
import resources from 'common/constants/resources';
import dataProvider from 'store/dataProvider';
import { phonesActionTypes } from '../reducer';

function* createPhone() {
  yield requestSaga({
    actionType: phonesActionTypes.create,
    request: dataProvider.createOne,
    resource: resources.phone.index,
  });
}

export default createPhone;
